// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pre-wrap{white-space:pre-wrap}#editable-div p{margin-top:0;margin-bottom:5px}.placeholder:empty:before{content:attr(data-text)!important;color:#ccc;cursor:text}.placeholder:empty{outline:none}.inline-block-scoped{display:inline-block}", ""]);
// Exports
module.exports = exports;
